import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { AutoNumericDirective } from './autonumeric.directive';
import { CurrencyInputComponent } from './currency-input.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    AutoNumericDirective,
    CurrencyInputComponent,
  ],
  exports: [CurrencyInputComponent, AutoNumericDirective],
})
export class CurrencyInputModule {}
